import {Component, OnInit} from '@angular/core';
import {BreadcrumbService} from "../../domain/services/breadcrumb/breadcrumb.service";
import {BreadcrumbModel} from "../../domain/models/breadcrumb.model";
import {MatIcon} from "@angular/material/icon";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-heading',
  standalone: true,
  imports: [
    MatIcon,
    NgIf
  ],
  templateUrl: './heading.component.html',
  styleUrl: './heading.component.css'
})
export class HeadingComponent implements OnInit {
  title: string | undefined;
  icon: string | undefined;

  constructor(private readonly breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe((newBreadcrumbs) => {
      const currentPage = newBreadcrumbs[newBreadcrumbs.length - 1];
      this.title = currentPage?.label;
      this.icon = currentPage?.icon;
    });
  }

}
